import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import { Home } from "./pages/Home";
import { MillLining } from "./pages/MillLining";
import { WearParts } from "./pages/WearParts";
import { OverlaySystems } from "./pages/OverlaySystems";
import { Laser } from "./pages/Laser";
import { PrecisionTurning } from "./pages/PrecisionTurning";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mill-lining" element={<MillLining />} />
          <Route path="/wear-parts" element={<WearParts />} />
          <Route path="/overlay-systems" element={<OverlaySystems />} />
          <Route path="/laser" element={<Laser />} />
          <Route path="/precision-turning" element={<PrecisionTurning />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
